import App from './App.vue';
import { user } from '@/beforeGuard/defaultRules';

export default {
  path: '/CDS_VF_SBSConnectResultDetail',
  name: 'CDS_VF_SBSConnectResultDetail',
  component: App,
  meta: {
    pageProperty: {
      title: 'SBS連携履歴',
      controller: 'CDS_CTR_SBSConnectResultDetail',
    },
    guardRules: [user],
  },
};
